<template>

  <!-- Public Layout -->
  <div
    class="public-layout">

    <q-layout
      view="hHh lpR lff">

      <page-drawer
        :menu="menu"
        v-model="drawer"/>

      <q-page-container>

        <q-page>

          <router-view/>

          <q-page-sticky
            expand
            position="top">

            <page-header
              :menu-items="menu"
              @drawer="drawer = !drawer"/>

          </q-page-sticky>

        </q-page>

      </q-page-container>

      <page-footer
        :menu-items="menu"/>

    </q-layout>

  </div>

</template>

<script>

  import {mapGetters} from 'vuex';
  import MetaMixin from '@src/mixins/meta-mixin';
  import PageHeader from '@src/components/page/page-header';
  import PageFooter from '@src/components/page/page-footer';
  import PageDrawer from '@src/components/page/page-drawer';

  export default {
    name: 'public-layout',
    mixins: [
      MetaMixin,
    ],
    components: {
      PageDrawer,
      PageHeader,
      PageFooter,
    },
    async preFetch({store}) {

      return Promise.all([
        store.dispatch(
          'vlNavigations/FETCH_ITEM',
        ),
        store.dispatch(
          'vlPrograms/START_LISTENING',
        ),
      ]);
    },
    data() {
      return {
        drawer: false,
        host: process.env.HOST_NAME,
      };
    },
    computed: {
      ...mapGetters('vlNavigations', {
        menu: 'menu',
      }),
    },
  };

</script>

<style lang="scss">

  .public-layout {

    .q-page {
      display: flex;
      overflow-x: hidden;
      flex-direction: column;
      background-color: #292633;
      box-shadow: 0 1px 0 #292633;
    }

    .q-page-sticky {
      z-index: 1;
    }
  }

</style>
